import { useEffect, useState } from 'react';
import { useGetUserCredentialsValidityAcQuery } from '../../../apiRtk/accessControlApi';
import { useCheckDormakabaAccessForUserMutation } from '../../../apiRtk/be4feApi';
import { IUser } from '../../../modules/user/store';
import { EnrichedIUser } from '../SectionPin';

interface IUseDormakabaAccess {
  companyId: number;
  siteId: number;
  user: IUser;
  userId: number;
}

function useDormakabaAccess({ companyId, siteId, user, userId }: IUseDormakabaAccess) {
  const [hasDormakabaAccessForUser, setHasDormakabaAccessForUser] = useState<boolean | undefined>(undefined);
  const [enrichedUser, setEnrichedUser] = useState(user as EnrichedIUser);

  const { data: userCredentialsValidityData } = useGetUserCredentialsValidityAcQuery({
    companyId: companyId.toString(),
    siteId: siteId.toString(),
    userId: userId.toString(),
  });
  const [checkDormakabaAccessForUser] = useCheckDormakabaAccessForUserMutation();

  useEffect(() => {
    checkDormakabaAccessForUser({ companyId, siteId, userId })
      .unwrap()
      .then(() => {
        setHasDormakabaAccessForUser(true);
      })
      .catch(() => {
        setHasDormakabaAccessForUser(false);
      });
  }, []);

  useEffect(() => {
    setEnrichedUser({
      ...user,
      validFrom: userCredentialsValidityData?.validFrom,
      validTo: userCredentialsValidityData?.validTo,
    });
  }, [userCredentialsValidityData]);

  return { enrichedUser, hasDormakabaAccessForUser };
}

export default useDormakabaAccess;
